<template>
  <div
    v-if="hasActiveTemplateCustomWebhooks"
    v-tooltip="`${$t('ORCHESTRATION.TRIGGER')} ${$t('COMMON.WEBHOOK')}`"
    class="modal-icon relative flex cursor-pointer items-center justify-center"
    data-cy="webhook-button"
    @click.stop="showManualWebhooks = !showManualWebhooks"
  >
    <icon-base :icon="IconWebhook" />
    <custom-webhooks-list
      v-if="showManualWebhooks"
      ref="webhooksList"
      :app-id="activeDeal.id"
      :items="activeTemplateCustomWebhooks"
      :style="webhooksDraggableBlockStyle"
      @close="showManualWebhooks = false"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import IconWebhook from "@/components/icons/IconWebhook.vue";
import { useDeals } from "@/hooks/deals";
import { useActiveWorkflowTemplate } from "@/hooks/workflow";
import CustomWebhooksList from "@/components/communication/CustomWebhooksList.vue";
import { useLocalStorageSetting } from "@/hooks/options";

const { activeDeal } = useDeals();
const { activeTemplateCustomWebhooks } = useActiveWorkflowTemplate();

const communicationToolOptions = useLocalStorageSetting(
  "communicationToolOptions",
  {
    x: 0,
    y: 0,
    showAsPopover: false
  }
);
const showManualWebhooks = ref(false);
const webhooksList = ref<InstanceType<typeof CustomWebhooksList> | null>(null);

const hasActiveTemplateCustomWebhooks = computed(
  () => !!Object.keys(activeTemplateCustomWebhooks.value).length
);

const webhooksDraggableBlockStyle = computed(() => {
  if (!webhooksList.value) {
    return {};
  }
  const webhooksListHeight = webhooksList.value.$el.clientHeight;
  if (communicationToolOptions.value.y <= webhooksListHeight) {
    return {
      left: "0px",
      top: "45px"
    };
  }
  return {
    left: "0px",
    bottom: "45px"
  };
});
</script>
